import { AcceptationGuideData } from '../../Interface/Response/Interest/AcceptationGuideData';
import { Label } from '../../Interface/Response/Interest/Label';

export const findForLabel = (allData: AcceptationGuideData[], label: Label): AcceptationGuideData =>
    allData.find(({ finDataCode }) => finDataCode === label.findataCode) as AcceptationGuideData;
